import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { label_class, select_class } from '../../functions/stateList'

export default function CarModalSelect({
  title,
  isSubmit,
  name,
  value,
  inputHandler,
  error,
  list,
  text_key,
}) {
  const [options, setOptions] = useState([])
  const [selectValue, setSelectValue] = useState({ label: '', value: '' })

  useEffect(() => {
    let arr = []
    for (let item of list) {
      if (text_key === 'full_name') {
        arr.push({ value: item?.id, label: item?.mobile })
      } else if (text_key === 'product_category') {
        arr.push({ value: item, label: item })
      } else {
        arr.push({ value: item?.id, label: item[text_key] })
      }
    }

    setOptions(arr)

    if (parseInt(value)) {
      let item =
        text_key === 'product_category'
          ? list.find((elem) => elem === parseInt(value))
          : list.find((elem) => elem.id === parseInt(value))

      setSelectValue(
        text_key === 'product_category'
          ? { value: item, label: item }
          : { value: item?.id, label: item[text_key] }
      )
    }
  }, [value, list])

  const handleSelect = ({ value }) => {
    let e = { target: { name, value } }
    setSelectValue({
      label: value,
      value,
    })
    inputHandler(e)
  }

  return (
    <label htmlFor={name} className={label_class}>
      {title}
      <Select
        className={`${select_class} dv-dark-input`}
        classNamePrefix="select"
        value={selectValue}
        isDisabled={isSubmit}
        isRtl
        isSearchable
        name={text_key === 'full_name' ? 'mobile' : null}
        options={options}
        onChange={handleSelect}
      />
      {error?.[name] && <p className={'text-rose-500'}>{error?.[name]}</p>}
    </label>
  )
}
